import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "text-black tw-font-bold" }
const _hoisted_3 = { class: "text-black" }
const _hoisted_4 = { class: "col" }

import { h, onBeforeMount, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import FormHeader from './FormHeader.vue'
import TypeAheadUsers from './TypeAheadUsers.vue'
import { useAPIURLs } from '../composables/useAPIURLs'
import { useOrderItemRules } from '../composables/useOrderItemRules'
import { QInput, QSelect } from 'quasar'

type ReasonOptions = { name: string; label: string }[]

//props
type HeaderProps = { header: string; subheaders: [string, string] }
type InputRenderingProps = {
  name: 'quantity' | 'reason' | 'comment' | 'reps'
  label?: string
}[]
type RenderOrderValues = 'quantity' | 'reason' | 'comment' | 'users'
type LabelValues = 'add' | 'adjust' | 'addToOrder'
type QuantityValues = 'quantity' | 'newQuantity'
type RenderOrderProps = RenderOrderValues[]
type ReasonOptionsProp = { name: string; show: boolean; reason_name: string }[]
type HideFieldsProps = { comment: boolean }
type LabelsProps = {
  action?: LabelValues
  quantity?: QuantityValues
}
type RenderType = { [key in RenderOrderValues]: { condition?: () => boolean; component: any } }

export default /*#__PURE__*/_defineComponent({
  __name: 'FormOrderItem',
  props: {
    headers: {},
    data: {},
    inputRendering: { default: () => [{ name: 'quantity' }, { name: 'reason' }, { name: 'comment' }] },
    reasonOptions: {},
    hideFields: { default: () => {
      return { comment: false }
    } },
    renderOrder: {},
    showRemove: { type: Boolean, default: false },
    allowZero: { type: Boolean, default: false },
    labels: { default: () => {
      return { action: 'addToOrder', quantity: 'quantity' }
    } }
  },
  emits: ["action", "remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props
//emit
const emit = __emit

//translations
const { t } = useI18n({ useScope: 'global' })
const formLabel = (key: string) => t(`form.${key}`)
const formOrderReasons = (key: string) => t(`form.orderReasons.${key}`)
const formError = (key: string) => t(`form.messages.${key}`)

//data
const quantity = ref()
const reason = ref()
const comment = ref()
const reasonOptions = ref<ReasonOptions>([])
const users = ref()
const toRep = ref()
onBeforeMount(() => {
  reasonOptions.value = props.reasonOptions
    .filter((reason) => reason.show)
    .map((reason) => {
      return {
        reason_name: reason.reason_name,
        name: reason.name,
        label: formOrderReasons(reason.name),
      }
    })
  quantity.value = props.data.quantity
})
onUnmounted(() => {
  //remove stale data
  quantity.value = undefined
  reason.value = undefined
  comment.value = undefined
  reasonOptions.value = []
  users.value = undefined
  toRep.value = undefined
})

//validation
const quantityRef = ref()
const reasonRef = ref()
const usersRef = ref()
const { itemNotNull, quantityAboveZero, quantityAboveEqualZero, noDecimalPlace } =
  useOrderItemRules({
    quantity,
    reason,
  })
const validate = () => {
  let quantityValidate = true
  let reasonValidate = true
  let usersValidate = true
  if (quantityRef.value) {
    quantityValidate = quantityRef.value.validate()
  }
  if (reasonRef.value) {
    reasonValidate = reasonRef.value.validate()
  }
  if (usersRef.value) {
    usersValidate = usersRef.value.validate()
    console.log(usersValidate)
  }
  return quantityValidate && reasonValidate && usersValidate
}

const submitOrder = () => {
  //validate
  if (validate()) {
    emit('action', {
      data: props.data,
      quantity:
        reason.value?.name === 'transfer' ? props.data.quantity - quantity.value : quantity.value,
      originalQuantity: props.data.quantity,
      reason: reason.value,
      comment: comment.value,
      users: users.value,
      toRep: toRep.value,
      date: new Date(),
    })
    close.value = true
  }
}
const close = ref(false)
const remove = () => {
  emit('remove', {
    data: props.data,
  })
}
const { API } = useAPIURLs()
const render: RenderType = {
  comment: {
    component: () =>
      h(QInput, {
        filled: true,
        modelValue: comment,
        hideBottomSpace: true,
        'onUpdate:modelValue': (value: any) => (comment.value = value),
        label: formLabel('comment'),
        type: 'textarea',
      }),
  },
  quantity: {
    component: () =>
      h(QInput, {
        ref: quantityRef,
        filled: true,
        hideBottomSpace: true,
        modelValue: quantity.value,
        'onUpdate:modelValue': (value: any) => (quantity.value = value),
        label:
          reason.value?.name === 'transfer'
            ? 'Transfer quantity'
            : formLabel(props.labels.quantity),
        rules: [
          (val: any) => itemNotNull(val) || formError('fieldNotNull'),
          (val: any) => noDecimalPlace(val) || formError('noDecimal'),
          props.allowZero
            ? (val: any) => quantityAboveEqualZero(val) || formError('notNegative')
            : (val: any) => quantityAboveZero(val) || formError('aboveZero'),
        ],
        type: 'number',
        mask: '###',
      }),
  },
  reason: {
    component: () =>
      h(QSelect, {
        ref: reasonRef,
        filled: true,
        hideBottomSpace: true,
        label: formLabel('reason'),
        modelValue: reason.value,
        'onUpdate:modelValue': (value: any) => {
          reason.value = value
        },
        rules: [(val: any) => itemNotNull(val) || formError('fieldNotNull')],
        lazyRules: true,
        options: reasonOptions.value,
      }),
  },
  users: {
    component: () =>
      h(TypeAheadUsers, {
        ref: usersRef,
        label: 'Rep',
        rules: [(val: any) => itemNotNull(val) || formError('fieldNotNull')],
        hideBottomSpace: true,
        lazyRules: true,
        modelValue: toRep.value,
        'onUpdate:modelValue': (value: any) => (toRep.value = value),
        route: API.value.getAreaStaffingUsers,
      }),
    condition: () => reason.value && reason.value.name === 'transfer',
  },
}

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, {
    style: {"min-width":"280px"},
    class: "q-pa-md"
  }, {
    default: _withCtx(() => [
      _createVNode(FormHeader, {
        "header-text": props.headers.header
      }, null, 8, ["header-text"]),
      _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(props.headers.subheaders[0]), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(props.headers.subheaders[1]), 1)
          ])
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderOrder, (node) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (
          'condition' in render[node] && typeof render[node]['condition'] !== 'undefined'
            ? render[node]['condition']!()
            : true
        )
            ? (_openBlock(), _createBlock(_component_q_card_section, {
                key: 0,
                class: "q-pt-none"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(render[node]['component'])))
                  ])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ], 64))
      }), 256)),
      _createVNode(_component_q_card_actions, {
        align: "right",
        class: "text-primary"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_btn, {
            flat: "",
            label: formLabel('close')
          }, null, 8, ["label"]), [
            [_directive_close_popup]
          ]),
          (_ctx.showRemove && _ctx.$props.data.quantity < 1)
            ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                flat: "",
                "no-caps": "",
                class: "text-negative",
                label: "Remove",
                onClick: _withModifiers(remove, ["stop"])
              }, null, 512)), [
                [_directive_close_popup]
              ])
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_q_btn, {
            color: "primary",
            label: formLabel(_ctx.labels.action),
            onClick: submitOrder
          }, null, 8, ["label"]), [
            [_directive_close_popup, close.value]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})